import { formatearFechaCompleta } from '../../../../utils/utils'
import React from 'react'
import { User,} from 'lucide-react';

const VistaSolicitudes = ({solicitud}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Tutores que han visto la solicitud</h3>
      
      <div className="grid gap-3">
        {solicitud.tutorVistaSolicitud.map((vista, index) => (
          <div key={index} className="bg-white p-4 rounded-lg border flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                <User size={20} className="text-blue-600" />
              </div>
              <div>
                <p className="font-medium">{vista.nombreTutor}</p>
                <p className="text-sm text-gray-600">Visto el {formatearFechaCompleta(vista.fechaConfirmacion)}</p>
              </div>
            </div>
            
          </div>
        ))}
      </div>
    </div>
  )
}

export default VistaSolicitudes
